import 'amfe-flexible';

import Vue from 'vue';
import App from './App';
import { router } from './router/index';

/**
 * 判断是否来自微信
 */
function isWeiXin() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}
let isWechat = isWeiXin()
Vue.prototype.$isWechat = isWechat

new Vue({
    router,
    el: '#app',
    render: h => h(App)
});